import React, { ReactElement } from 'react'
import { FormattedMessage } from 'react-intl'

import { Container2, Container3 } from './styles'

interface Props {
    title?: object
    msgId?: string
    style?: object
}

export default function Title({}: Props): ReactElement {
    return (
        <div>

        </div>
    )
}


export function H2({title, msgId, style}: Props): ReactElement {
    return (
        <Container2 style={style}>
            <h2>
                {msgId ? <FormattedMessage id={msgId} /> : title }
            </h2>
        </Container2>
    )
}
export function H3({title, msgId, style}: Props): ReactElement {
    return (
        <Container3 style={style}>
            <h3>
                {msgId ? <FormattedMessage id={msgId} /> : title }
            </h3>
        </Container3>
    )
}
